import { AxiosError, AxiosResponse } from 'axios';
import * as api from 'data/datasources/v1/MigrationRunbook';
import {
    ActorRequest,
    MigrationRun,
    MigrationRunUpsert,
    RunbookActivity,
    RunbookTask,
    RunbookTemplate,
    RunbookTemplateUpsert,
    RunSearch,
    TaskUpdate
} from 'data/schemas/MigrationRunbook';
async function value<T>(promise: Promise<AxiosResponse<T>>): Promise<T> {
    try {
        const response = await promise;
        return response.data;
    } catch (error) {
        if (error instanceof AxiosError && error.response) {
            const body = error.response.data as { message?: string } | string | undefined;
            const message = typeof body === 'string' ? body : body?.message;
            throw new Error(
                message || `Migration Runbook request failed (${error.response.status}).`
            );
        }
        throw new Error(
            error instanceof Error ? error.message : 'Migration Runbook request failed.'
        );
    }
}
export const getTemplates = (): Promise<RunbookTemplate[]> => value(api.retrieveTemplates());
export const getTemplate = (id: string): Promise<RunbookTemplate> =>
    value(api.retrieveTemplate(id));
export const saveTemplate = (body: RunbookTemplateUpsert, id?: string): Promise<RunbookTemplate> =>
    value(id ? api.updateTemplate(id, body) : api.createTemplate(body));
export const deleteTemplate = (id: string, body: ActorRequest) =>
    value(api.removeTemplate(id, body));
export const copyTemplate = (id: string, body: ActorRequest): Promise<RunbookTemplate> =>
    value(api.cloneTemplate(id, body));
export const getRuns = (params: RunSearch): Promise<MigrationRun[]> =>
    value(api.retrieveRuns(params));
export const getRun = (id: string, citizen: string, teams: string): Promise<MigrationRun> =>
    value(api.retrieveRun(id, citizen, teams));
export const saveRun = (body: MigrationRunUpsert, id?: string): Promise<MigrationRun> =>
    value(id ? api.updateRun(id, body) : api.createRun(body));
export const copyRun = (id: string, body: ActorRequest): Promise<MigrationRun> =>
    value(api.cloneRun(id, body));
export const changeRunStatus = (
    id: string,
    action: string,
    body: ActorRequest
): Promise<MigrationRun> => value(api.transitionRun(id, action, body));
export const saveTask = (runId: string, taskId: string, body: TaskUpdate): Promise<RunbookTask> =>
    value(api.updateTask(runId, taskId, body));
export const changeTaskStatus = (
    runId: string,
    taskId: string,
    action: string,
    body: ActorRequest
): Promise<RunbookTask> => value(api.transitionTask(runId, taskId, action, body));
export const getActivity = (
    runId: string,
    citizen: string,
    teams: string
): Promise<RunbookActivity[]> => value(api.retrieveActivity(runId, citizen, teams));
